export interface AddGroup {
  group_name: string;
  group_notes: string;
  users_ids: GroupUserDetail[];
  client_ids: GroupClientDetail[];
  individual_check: boolean;
  client_check: boolean;
  group_id?: string;
}

export interface GroupList {
  addedBy: string;
  addedOn: Date | string;
  addedbyName: string;
  comments: string;
  customer_id: string;
  group_id: string;
  group_name: string;
  status: string;
}

export interface GroupUserDetail {
  first_name: string;
  group_id: string;
  group_name: string;
  last_name: string;
  user_id: string;
  usr_country: string;
  usr_designation: string;
  usr_email: string;
  usr_mobile: string;
  comments: string;
  usr_fullName: string;
}

export interface GroupClientDetail {
  company_contact: string;
  company_emailid: string;
  company_id: string;
  company_name: string;
  group_id: string;
  group_name: string;
  comments: string;
}
